var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Toolbar'),(_vm.access.locked)?_c('v-main',[_c('LockScreen')],1):[_c('Breadcrumbs'),_c('v-main',[_c('v-container',{staticClass:"main-container"},[_c('router-view')],1)],1)],_c('Footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }